import {
    DELETE_INVITATION,
    DELETE_INVITATION_FAILURE,
    DELETE_INVITATION_SUCCESS,
} from 'store/actions/types';

export const deleteInvitation = (payload) => {
    return {
        type: DELETE_INVITATION,
        payload: payload,
    };
};

export const deleteInvitationFailure = (error) => {
    return {
        type: DELETE_INVITATION_FAILURE,
        payload: error,
    };
};

export const deleteInvitationSuccess = (payload) => {
    return {
        type: DELETE_INVITATION_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accounts/invitations/deleteInvitations.js